import ls from 'local-storage'

const state = ({
  kkmServerProxyEnabled: false,
  kkmServerFilialId: null,
  kkmServerToken: null,
  kkmServerUrl: null,
  // состояние вочдога KkmServer (kkmWatchdog): версия, старт, последний ответ, статус; в localStorage не пишется
  kkmServerInfo: null,
})

const mutations = {
  setKkmServerSettings (state, { kkmServerProxyEnabled, kkmServerFilialId, kkmServerToken, kkmServerUrl }) {
    state.kkmServerProxyEnabled = kkmServerProxyEnabled
    state.kkmServerFilialId = kkmServerFilialId
    state.kkmServerToken = kkmServerToken
    state.kkmServerUrl = kkmServerUrl

    console.log('setKkmServerSettings mutation call')
  },
  setKkmServerInfo (state, info) {
    state.kkmServerInfo = info
  },
}

const getters = {
  isKkmServerProxyEnabled: state => state.kkmServerProxyEnabled,
  getKkmServerFilialId: state => state.kkmServerFilialId,
  getKkmServerToken: state => state.kkmServerToken,
  getKkmServerUrl: state => state.kkmServerUrl,
  getKkmServerInfo: state => state.kkmServerInfo,
}

const actions = {
  saveKkmServerSettings ({ commit, dispatch }, payload) {
    console.log('saveKkmServerSettings', payload)
    commit('setKkmServerSettings', payload)
    dispatch('saveStateToLocalStorage')
  },
  saveStateToLocalStorage ({ state }) {
    console.log('saveStateToLocalStorage action', state)
    ls.set('kkmServerProxyEnabled', state.kkmServerProxyEnabled)
    ls.set('kkmServerFilialId', state.kkmServerFilialId)
    ls.set('kkmServerToken', state.kkmServerToken)
    ls.set('kkmServerUrl', state.kkmServerUrl)
  },

  setStateFromLocalStorage ({ commit }) {
    const kkmServerProxyEnabled = !!ls.get('kkmServerProxyEnabled')
    const kkmServerFilialId = ls.get('kkmServerFilialId') || null
    const kkmServerToken = ls.get('kkmServerToken') || null
    const kkmServerUrl = ls.get('kkmServerUrl') || null
    commit('setKkmServerSettings', { kkmServerProxyEnabled, kkmServerFilialId, kkmServerToken, kkmServerUrl })
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
